import UserDetails from './UserDetails';
import UserWalletInfo from './UserWalletInfo';
import { useSelector } from 'react-redux';
import { ReducerState } from '@/services/common/lib/reducerState';

const UserProfile = () => {
  const user = useSelector((state: ReducerState) => state.auth);

  if (!user || !user.id || !user.alias) {
    return null;
  }

  return (
    <div className="h-max w-[300px] min-w-[300px] rounded-[40px] bg-pn-violet-medium">
      <UserDetails userId={user.id} alias={user.alias} />

      <UserWalletInfo />
    </div>
  );
};

export default UserProfile;
